import React from 'react';
import LoadingSpinner from './LoadingSpinner';
import styles from './InlineSpinner.module.css';

interface InlineSpinnerProps {
  size?: 'small' | 'medium' | 'large';
  color?: string;
  className?: string;
}

const InlineSpinner: React.FC<InlineSpinnerProps> = ({ 
  size = 'small', 
  color = 'var(--primary-color)',
  className = ''
}) => {
  return (
    <div className={`${styles.inlineSpinner} ${className}`}>
      <LoadingSpinner size={size} color={color} />
    </div>
  );
};

export default InlineSpinner;
